import { CheckListNode } from "./checklist_node";
//struttura dati checklist principale
export class CheckList {
        name: string = "";
        childNodes: Array<CheckListNode> = [];
}